import React, { useState, useEffect, useRef } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const CustomDropdown = ({
    options,
    value,
    onChange,
    placeholder,
    required,
    isWhiteLabelingEnable = true,
    error = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            setIsOpen(!isOpen);
            e.preventDefault();
        }
        if (e.key === "Escape") {
            setIsOpen(false);
        }
    };

    return (
        <div className="relative bg-slate" ref={dropdownRef}>
            <div
                className={`w-full px-4 py-3 bg-transparent border ${error ? "border-red-500" : "border-gray-400"} rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#C1A0D0] transition-colors flex justify-between items-center cursor-pointer`}
                onClick={() => setIsOpen(!isOpen)}
                onKeyDown={handleKeyDown}
                tabIndex={0}
                role="combobox"
                aria-expanded={isOpen}
                aria-controls="dropdown-options"
            >
                {value ? (
                    <span
                        className={`${isWhiteLabelingEnable ? "text-gray-700" : "text-gray-300"}`}
                    >
                        {value}
                    </span>
                ) : (
                    <span className="text-gray-400 text-sm whitespace-nowrap">
                        {placeholder}
                    </span>
                )}

                {isOpen ? (
                    <ChevronUp className="w-5 h-5 text-gray-400" />
                ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400" />
                )}
            </div>
            {isOpen && (
                <ul
                    id="dropdown-options"
                    className="absolute z-10 w-full mt-1 bg-white dark:bg-[#1a1f2e] border border-gray-400 dark:border-gray-600 rounded-lg shadow-lg max-h-48 overflow-auto"
                    role="listbox"
                >
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className={`px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-[#C1A0D0]/20 cursor-pointer ${value === option ? "bg-slate-100 dark:bg-[#2a2f3e]" : ""
                                }`}
                            onClick={() => {
                                onChange(option);
                                setIsOpen(false);
                            }}
                            role="option"
                            aria-selected={value === option}
                        >
                            {option}
                        </li>
                    ))}
                </ul>
            )}
            {required && !value && (
                <input type="hidden" value={value} required className="hidden" />
            )}
        </div>
    );
};

export default CustomDropdown;
